import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const SuccessMessage = ({ show, onClose}) => {

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Investment Successful!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="success-message">
        <h4>🎉 Congratulations! 🎉</h4>
<p>Your investment is complete. Thank you for choosing us!</p>
<p>For more info, check your email, raise a ticket, or chat with Admin.</p>
<p>Close to read the Background Note, then reload to view your plan.</p>
         
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessMessage;
